import { r as reducer } from "../SrmDebug.ducks-944cbd53.js";
const moduleReducer = {
  srmDebugModule: reducer
};
export {
  moduleReducer as default,
  moduleReducer
};
//# sourceMappingURL=reducers.js.map
